<template>
  <div class="admin-dashboard">
    <h2>仪表盘</h2>
    <p class="welcome">欢迎，{{ auth.user ? auth.user.name : '管理员' }}。</p>
    <el-alert
      type="info"
      :closable="false"
      title="管理端框架已就绪"
      description="具体功能模块后续逐步接入，左侧菜单可直接追加。"
    />
  </div>
</template>

<script>
import auth from '../auth'

export default {
  name: 'AdminDashboard',
  computed: {
    auth() {
      return auth
    },
  },
}
</script>

<style scoped>
.admin-dashboard {
  padding: 24px;
  text-align: left;
}
.welcome {
  color: #555;
}
</style>



// WEBPACK FOOTER //
// src/admin/views/Dashboard.vue